var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "section", attrs: { "scope-slot": "empty" } },
    [
      _c("div", { staticClass: "content has-text-grey has-text-centered" }, [
        _c("p", [
          _vm._v(_vm._s(_vm.tableType) + " will appear here once configured"),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }